"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiChargeResponseDto = void 0;
const billing_api_account_response_dto_1 = require("../../../billing-api-account/types/dtos/billing-api-account-response.dto");
const billing_api_payment_response_dto_1 = require("../../../billing-api-payment/types/dtos/billing-api-payment-response.dto");
const billing_api_refund_response_dto_1 = require("../../../billing-api-refund/types/dtos/billing-api-refund-response.dto");
const billing_api_fn_1 = require("../../../shared/billing-api-fn");
const billing_core_charge_cancel_reason_enum_1 = require("../../../../billing-core/billing-core-charge/types/enums/billing-core-charge-cancel-reason.enum");
const billing_core_charge_payout_status_enum_1 = require("../../../../billing-core/billing-core-charge/types/enums/billing-core-charge-payout-status.enum");
const billing_core_charge_status_enum_1 = require("../../../../billing-core/billing-core-charge/types/enums/billing-core-charge-status.enum");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const billing_api_charge_dto_1 = require("./billing-api-charge.dto");
let BillingApiChargeResponseDto = class BillingApiChargeResponseDto extends billing_api_charge_dto_1.BillingApiChargeAbstractDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id начисления",
  format: "uuid"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiChargeResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата создания начисления",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsDate)(), (0, transform_iso8601_date_1.default)(), __metadata("design:type", Date)], BillingApiChargeResponseDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата обновления начисления",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsDate)(), (0, transform_iso8601_date_1.default)(), __metadata("design:type", Date)], BillingApiChargeResponseDto.prototype, "updatedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Статус начисления из классификатора",
  enum: billing_core_charge_status_enum_1.BillingCoreChargeStatusEnum
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsEnum)(billing_core_charge_status_enum_1.BillingCoreChargeStatusEnum), __metadata("design:type", String)], BillingApiChargeResponseDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id платежа. Появляется после попытки оплаты начисления.",
  format: "uuid",
  type: String,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiChargeResponseDto.prototype, "paymentId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id возврата. Появляется после отмены оплаченного начисления.",
  format: "uuid",
  type: String,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiChargeResponseDto.prototype, "refundId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Дата подтверждения оказания услуги или продажи товара.
    Выставляется действием confirm со стороны сервиса-клиента биллинга подтверждая,
    что услуга/товар были оказаны запуская процесс рассчёта с поставщиком и комиссионерами.`,
  format: "date-time",
  type: String,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Object)], BillingApiChargeResponseDto.prototype, "comfirmedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Дата отмены начисления, после отмены оплатить невозможно.
    При отмене уже оплаченного начисления, запускается процесс вовзрата денежных средств.`,
  format: "date-time",
  type: String,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Object)], BillingApiChargeResponseDto.prototype, "canceledAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Причина отмены из классификатора",
  enum: billing_core_charge_cancel_reason_enum_1.BillingCoreChargeCancelReasonEnum,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_core_charge_cancel_reason_enum_1.BillingCoreChargeCancelReasonEnum), __metadata("design:type", Object)], BillingApiChargeResponseDto.prototype, "cancelReason", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сообщение уточнющее информацию об отмене.",
  type: String,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsString)(), __metadata("design:type", Object)], BillingApiChargeResponseDto.prototype, "cancelMessage", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Статус выплаты",
  nullable: true,
  enum: billing_core_charge_payout_status_enum_1.BillingCoreChargePayoutStatusEnum
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiChargeResponseDto.prototype, "payoutStatus", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Количество попыток выплаты",
  nullable: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiChargeResponseDto.prototype, "payoutAttempts", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Список ошибок (если есть)",
  nullable: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiChargeResponseDto.prototype, "payoutErrors", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Счёт (доступно при использовании include-опций запроса)",
  ...(0, billing_api_fn_1.swaggerRef)("BillingApiAccountResponseDto")
}), __metadata("design:type", billing_api_account_response_dto_1.BillingApiAccountResponseDto)], BillingApiChargeResponseDto.prototype, "account", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Платёж (доступно при использовании include-опций запроса)",
  ...(0, billing_api_fn_1.swaggerRef)("BillingApiPaymentResponseDto")
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.ValidateNested)(), (0, class_transformer_1.Type)(() => billing_api_payment_response_dto_1.BillingApiPaymentResponseDto), __metadata("design:type", billing_api_payment_response_dto_1.BillingApiPaymentResponseDto)], BillingApiChargeResponseDto.prototype, "payment", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Возврат (доступно при использовании include-опций запроса)",
  ...(0, billing_api_fn_1.swaggerRef)("BillingApiRefundResponseDto")
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.ValidateNested)(), (0, class_transformer_1.Type)(() => billing_api_refund_response_dto_1.BillingApiRefundResponseDto), __metadata("design:type", billing_api_refund_response_dto_1.BillingApiRefundResponseDto)], BillingApiChargeResponseDto.prototype, "refund", void 0);
BillingApiChargeResponseDto = __decorate([(0, swagger_1.ApiExtraModels)(billing_api_payment_response_dto_1.BillingApiPaymentResponseDto)], BillingApiChargeResponseDto);
exports.BillingApiChargeResponseDto = BillingApiChargeResponseDto;
